import { CHESS_RUSSIAN_META } from '@features/chessrussian/customizations/club-page/chessrussian-meta';
import { IClubMeta } from '@features/club/typings-meta';
import { NO_TICKETS_MARK } from '@features/club/utils/event-sections';

// Клуб без меты: один раздел со всеми событиями
const DEFAULT_CLUB_META: IClubMeta = {
  eventSections: [{ id: 'events', news: true }],
};

// TODO: перенести в ClubDto.frontendMeta
const CLUB_META: Record<string, IClubMeta> = {
  '777': CHESS_RUSSIAN_META,
  // тестовый открытый клуб
  '201': CHESS_RUSSIAN_META,
  // НСШЛ
  '1001': {
    eventSections: [
      {
        id: 'vuz',
        title: 'ВУЗы',
        ticket: 'vuz',
        // сюда же попадают старые турниры без тикетов
        filter: { tickets: ['vuz', NO_TICKETS_MARK] },
        news: true,
      },
      { id: 'college', title: 'Колледжи', ticket: 'college' },
    ],
  },
};

export function getClubMeta(clubId: string): IClubMeta {
  return CLUB_META[clubId] ?? DEFAULT_CLUB_META;
}
